import React from 'react';
import { ModuleContentTemplate } from './ModuleContentTemplate';
import { module7Config } from '../config/moduleConfigs';

interface User {
  id: string;
  email: string;
  fullName: string;
  company: string;
  role: string;
  status: string;
}

interface Module7ContentProps {
  user: User | null;
  onLogout: () => void;
  isPreviewMode?: boolean;
  invitationEmail?: string;
  isAdminMode?: boolean;
  inviteToken?: string;
}

export function Module7Content({ 
  user, 
  onLogout, 
  isPreviewMode = false, 
  invitationEmail, 
  isAdminMode = false, 
  inviteToken 
}: Module7ContentProps) {
  return (
    <ModuleContentTemplate
      user={user}
      onLogout={onLogout}
      moduleId={7}
      moduleConfig={module7Config}
      isPreviewMode={isPreviewMode}
      invitationEmail={invitationEmail}
      isAdminMode={isAdminMode}
      inviteToken={inviteToken}
    />
  );
}

